var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive)?_c('div',{attrs:{"id":"scroll-top"},on:{"click":function($event){return _vm.handleClick()}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }